import { render, staticRenderFns } from "./cookizComponent.vue?vue&type=template&id=72b725b6&scoped=true&"
import script from "./cookizComponent.vue?vue&type=script&lang=js&"
export * from "./cookizComponent.vue?vue&type=script&lang=js&"
import style0 from "./cookizComponent.vue?vue&type=style&index=0&id=72b725b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b725b6",
  null
  
)

export default component.exports